
export const routerReport = {
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$store.dispatch('reportPageView', to.path)
      vm.$store.dispatch('startPageSession')
    })
  },
  beforeRouteUpdate (to, from, next) {
    this.$store.dispatch('reportPageView', to.path)
    this.$store.dispatch('startPageSession')
    next()
  },
  beforeRouteLeave (to, from, next) {
    this.$store.dispatch('reportPageSession', from.path)
    next()
  }
}
